"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("../../Themes/styled-components"));
const Content = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  height: 100%;
  width: 100%;
`;
const Top = styled_components_1.default.div `
  z-index: 1;
`;
const Bottom = styled_components_1.default.div `
  z-index: 1;
`;
const MainWrapper = styled_components_1.default.div `
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1 0 0;
`;
const Main = styled_components_1.default.div `
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;
const ScrollLayout = ({ topFixed, children, bottomFixed, className, }) => (React.createElement(Content, { className: className },
    React.createElement(Top, null, topFixed),
    React.createElement(MainWrapper, null,
        React.createElement(Main, null, children)),
    React.createElement(Bottom, null, bottomFixed)));
exports.default = ScrollLayout;
